module.exports = __webpack_public_path__ + "img/AM.ed9d104f.png";